import { useEnabledMaContractsQuery, useEnabledPdpContractsQuery } from '@coverright/data-access/medicare';
import { mainBackendApolloClient } from '@coverright/data-access/apollo-clients';
import _ from 'lodash';

export const usePlanContracts = (type: 'ma' | 'pdp') => {
  const options = {client: mainBackendApolloClient, notifyOnNetworkStatusChange: true}
  const maData = useEnabledMaContractsQuery({ ...options, skip: type !== 'ma' });
  const pdpData = useEnabledPdpContractsQuery({ ...options, skip: type !== 'pdp' });

  const data = type === 'ma' ? maData : pdpData;
  const contracts = type === 'ma' ? maData.data?.enabledPbpContracts || [] : pdpData.data?.enabledPdpContracts || [];

  return {
    loading: data.loading,
    contracts: contracts.map(i => _.omit(i, '__typename')).sort(),
  }
}
